import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();

const token = getToken();

export const CouponCodeApi = {
    getAllCouponCodes: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.GET_ALL_COUPON_CODES}`,  // e.g., "/superadmin/fetch-coupons"
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    getCouponCodeById: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.GET_COUPON_CODE_BY_ID}`,  // e.g., "/superadmin/fetch-coupon-by-id"
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    createCouponCode: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.CREATE_COUPON_CODE}`,  // e.g., "/superadmin/create-coupon"
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    updateCouponCode: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.UPDATE_COUPON_CODE}`,  // e.g., "/superadmin/update-coupon"
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    deleteCouponCode: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.DELETE_COUPON_CODE}`,  // e.g., "/superadmin/delete-coupon"
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    }
};
